
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#8E8E92","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M7.61 11.856a.487.487 0 00-.488-.487H5.42a.487.487 0 00-.488.487v1.702c0 .27.219.488.488.488h1.702c.27 0 .488-.218.488-.488v-1.702zM11.864 11.856a.487.487 0 00-.488-.487H9.674a.487.487 0 00-.488.487v1.702c0 .27.219.488.488.488h1.702a.488.488 0 00.488-.488v-1.702zM16.118 11.856a.487.487 0 00-.488-.487h-1.702a.487.487 0 00-.488.487v1.702c0 .27.219.488.488.488h1.702c.27 0 .488-.218.488-.488v-1.702zM7.61 16.11a.487.487 0 00-.488-.487H5.42a.487.487 0 00-.488.488v1.701c0 .27.219.488.488.488h1.702c.27 0 .488-.218.488-.488v-1.701zM11.864 16.11a.487.487 0 00-.488-.487H9.674a.487.487 0 00-.488.488v1.701c0 .27.219.488.488.488h1.702a.488.488 0 00.488-.488v-1.701zM16.118 16.11a.487.487 0 00-.487-.487h-1.703a.487.487 0 00-.488.488v1.701c0 .27.219.488.488.488h1.703a.488.488 0 00.487-.488v-1.701z"}}),_c('path',{attrs:{"d":"M19.162 2.393v2.6a2.123 2.123 0 01-2.128 2.121H15.69c-1.175 0-2.14-.946-2.14-2.122V2.384H7.5v2.608a2.134 2.134 0 01-2.14 2.122H4.016a2.123 2.123 0 01-2.128-2.122v-2.6c-1.027.032-1.87.881-1.87 1.926v15.235c0 1.064.861 1.937 1.925 1.937h17.162a1.938 1.938 0 001.926-1.937V4.318a1.935 1.935 0 00-1.87-1.925zm-.624 16.211c0 .46-.373.833-.833.833H3.308a.833.833 0 01-.833-.833v-7.87c0-.46.373-.832.833-.832h14.397c.46 0 .833.373.833.833v7.869z"}}),_c('path',{attrs:{"d":"M4.012 5.72H5.34a.73.73 0 00.73-.729V.73A.73.73 0 005.34 0H4.012a.73.73 0 00-.73.73V4.99c0 .403.327.73.73.73zM15.674 5.72h1.328a.73.73 0 00.73-.729V.73a.73.73 0 00-.73-.73h-1.328a.73.73 0 00-.73.73V4.99c0 .403.327.73.73.73z"}})])])
          )
        }
      }
    